import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Mail, Copy, Check, Code } from "lucide-react";
import { GithubIcon, LinkedinIcon } from "../components/common/icons";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import SectionHeader from "../components/common/sectionHeader";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact") || SEO[4];

	const handleCopyEmail = () => {
		navigator.clipboard.writeText(INFO.main.email);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Contact | ${INFO.main.name}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta name="keywords" content={currentSEO.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="contact" />

				<main className="content-wrapper">
					<div className="contact-page-container">
						<SectionHeader
							tag="Direct Communication"
							title="Let's build"
							highlight="something useful."
							subtitle="I'm interested in software engineering opportunities, interesting technical problems, and conversations around backend engineering, Spring Boot, system design, AI, and building products."
						/>

						<div className="contact-card-main">
							<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
								<Mail size={24} color="#06b6d4" />
								<h3 style={{ margin: 0, fontSize: "1.25rem", color: "var(--primary-color)" }}>
									Primary Email Address
								</h3>
							</div>

							<p style={{ color: "var(--secondary-color)", margin: 0, lineHeight: 1.6 }}>
								Feel free to reach out directly via email. I aim to respond to technical inquiries and messages within 24 hours.
							</p>

							<div className="contact-email-box">
								<span className="contact-email-text">{INFO.main.email}</span>
								<button className="copy-btn" onClick={handleCopyEmail}>
									{copied ? <Check size={14} /> : <Copy size={14} />}
									<span>{copied ? "Copied!" : "Copy Email"}</span>
								</button>
							</div>
						</div>

						<div className="contact-channels-grid">
							<a
								href={INFO.socials.linkedin}
								target="_blank"
								rel="noreferrer"
								className="channel-card"
							>
								<div className="channel-title">
									<LinkedinIcon size={20} color="#06b6d4" />
									<span>LinkedIn Profile</span>
								</div>
								<p className="channel-desc">
									Connect professionally and follow my engineering milestones & updates.
								</p>
							</a>

							<a
								href={INFO.socials.github}
								target="_blank"
								rel="noreferrer"
								className="channel-card"
							>
								<div className="channel-title">
									<GithubIcon size={20} color="#10b981" />
									<span>GitHub Repositories</span>
								</div>
								<p className="channel-desc">
									Inspect my open-source code repositories, full-stack projects, and commit activity.
								</p>
							</a>

							<a
								href={INFO.socials.leetcode}
								target="_blank"
								rel="noreferrer"
								className="channel-card"
							>
								<div className="channel-title">
									<Code size={20} color="#6366f1" />
									<span>LeetCode Profile</span>
								</div>
								<p className="channel-desc">
									Explore my algorithm practice, contest submissions (1813 Peak Rating), and problem-solving history.
								</p>
							</a>
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</main>
			</div>
		</React.Fragment>
	);
};

export default Contact;
